@if (checking()) {
    <qpx-loading-state ariaLabel="Checking building access" />
} @else {
    <qpx-error-state
        class="w-full"
        [heading]="error.title"
        visualSize="hero"
        [error]="error"
        role="alert"
    >
        <button
            qpxButton
            matButton="elevated"
            size="sm"
            context="primary"
            (click)="retryRequested.emit()"
        >
            <span>Retry access check</span>
        </button>
    </qpx-error-state>
}
